import { useAuth } from 'hooks/auth/useAuth';
import { useAdminPermissions } from 'hooks/auth/useAdminPermissions';
import { useStakeholderPermissions } from 'hooks/auth/useStakeholderPermissions';
import { PermissionClaims } from '@freetech/models/user';
import { createEmptyAdminPermissions } from 'constants/permissions';
import { createEmptyStakeholderPermissions } from 'constants/stakeholderPermissions';

export const useUnifiedPermissions = () => {
  const { role } = useAuth();
  const { 
    permissions: adminPermissions, 
    isPermissionsLoading: isAdminPermissionsLoading 
  } = useAdminPermissions();
  const { 
    permissions: stakeholderPermissions, 
    isPermissionsLoading: isStakeholderPermissionsLoading 
  } = useStakeholderPermissions();


  const permissions: PermissionClaims | null = (() => {
    if (!role) return null;
    
    switch (role) {
      case "admin":
        return adminPermissions || createEmptyAdminPermissions();
      case "stakeholder":
        return stakeholderPermissions || createEmptyStakeholderPermissions();
      case "freelancer":
      case "student":
        return createEmptyAdminPermissions(); // These roles don't need complex permissions
      default:
        return null;
    }
  })();


  const isPermissionsLoading = (() => {
    if (!role) return true;   
    
    switch (role) {
      case "admin":
        return isAdminPermissionsLoading;
      case "stakeholder":
        return isStakeholderPermissionsLoading;
      case "freelancer":
      case "student":
        return false; // These roles don't need to wait for permissions
      default:
        return false;
    }
  })();

  return {
    permissions,
    isPermissionsLoading,
  };
}; 